import Banner01 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_01.jpeg';
import Banner02 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_02.jpeg';
import Banner03 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_03.jpeg';
import Banner04 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_04.jpeg';
import Banner05 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_05.jpeg';
import Banner06 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_06.jpeg';
import Banner07 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_07.jpeg';
import Banner08 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_08.jpeg';
import Banner09 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_09.jpeg';
import Banner10 from '../assets/graphics/jpeg/default-banners/Personal_MyPage_PresetBanner_10.jpeg';

export const DEFAULT_BANNERS: string[] = [
  Banner01,
  Banner02,
  Banner03,
  Banner04,
  Banner05,
  Banner06,
  Banner07,
  Banner08,
  Banner09,
  Banner10,
];
